import React, { useState, useEffect, useCallback, useRef } from "react";
import { BottomScrollListener, useBottomScrollListener } from "react-bottom-scroll-listener";
import ErrorModal from "./ErrorModal";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import AddressFormContainerModal from "./AddressFormContainerModal";
import ShipmentDataModal from "./ShipmentDataModal";
import {
  CURRENCY_EURO, DEFAULT_PER_PAGE_PARAM,
  IPAD_WIDTH,
  isValidUserAddress, parseAmount,
  parseGradeOverall, parseUserFullName, pluralize,
  titleize
} from "../../utils/utils";
import RejectingModal from "../../backoffice/components/RejectingModal";
import I18n from 'i18n.js.erb'
import { DESKTOP_WIDTH, parseBigInteger, scrollManagerInTabPages, parseOrderState, parseItemCondition } from "../../utils/utils";
import ShowLargeImageModal from "./ShowLargeImageModal";
import IconTooltip from "./IconTooltip";
import AlertPopup from "./AlertPopup";
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import PDFGenerator from "./PDFGenerator";
import EncasingParser from "./EncasingParser";
import BlueprintImageTableRaw from "./BlueprintImageTableRow";
import BlueprintImageAccordionContent from "./BlueprintImageAccordionContent";
import {
  BlueprintImageAccordionTitleIcon,
  BlueprintImageAccordionTitleImage,
  BlueprintImageAccordionTitleName
} from "./BlueprintImageAccordionTitle";
import LanguageFlag from "./LanguageFlag";
import SuccessFlashMessage from "./SuccessFlashMessage";
import GradingCertificate from "./GradingCertificate";

const OrderPage = ({
  initialOrder,
  orderType,
  sorting_options,
  sorting_directions,
  countries,
  couriers,
  possibleOrderItemsRejectingCauses,
  possibleOrdersRejectingCauses,
  isBusinessAccount
}) => {

  const originalOrder = JSON.parse(initialOrder)
  const [initCompleted, setInitCompleted] = useState(false)
  const [orderItems, setOrderItems] = useState([]);
  const [orderState, setOrderState] = useState(originalOrder.state)
  const [rejectionReason, setRejectionReason] = useState(originalOrder.rejection_reason)
  const initialFilters = { warning_cards: null, sort_by: 'id', sorting_direction: 'asc' }
  const [filters, setFilters] = useState(initialFilters)
  const [page, setPage] = useState(1);
  const [hasLoadedAllOrderItems, setHasLoadedAllOrderItems] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [shipmentAddress, setShipmentAddress] = useState(originalOrder.shipment_address ? { ...originalOrder.shipment_address } : null)
  const [showSuccessFlashMessage, setShowSuccessFlashMessage] = useState(false)
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [isOrderInProgress, setIsOrderInProgress] = useState(false);
  const [orderToSetShipmentData, setOrderToSetShipmentData] = useState(null)
  const [shipmentDataToUpdate, setShipmentDataToUpdate] = useState(null)
  const [couriersToRender, setCouriersToRender] = useState(couriers);
  const [courierCompany, setCourierCompany] = useState(originalOrder.courier)
  const [trackNumber, setTrackNumber] = useState(originalOrder.tracking_number)
  const [orderItemToReject, setOrderItemToReject] = useState(null);
  const [orderToReject, setOrderToReject] = useState(null);
  const [rejectingCause, setRejectingCause] = useState("not_received");
  const [otherRejectingCause, setOtherRejectingCause] = useState("");
  const [atLeastOneOrderItemWithoutState, setAtLeastOneOrderItemWithoutState] = useState(false);
  const [showZoomImg, setShowZoomImg] = useState(false)
  const [blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage] = useState(null)
  const [actionsPannelIsOpen, setActionsPannelIsOpen] = useState($(window).innerWidth() >= DESKTOP_WIDTH);
  const [showSetInProgressOrderAlertPopup, setShowSetInProgressOrderAlertPopup] = useState(false)
  const [showSetRejectedOrderAlertPopup, setShowSetRejectedOrderAlertPopup] = useState(false)
  const [showSentOrderAlertPopup, setShowSentOrderAlertPopup] = useState(false)
  const [showReceiveAllProductInOrderAlertPopup, setShowReceiveAllProductInOrderAlertPopup] = useState(false)
  const [showAlertProblemOnAllProductAlertPopup, setShowAlertProblemOnAllProductAlertPopup] = useState(false)
  const [showSetAsRecivedSingleProductAlertPopup, setShowSetAsRecivedSingleProductAlertPopup] = useState(false)
  const [productToMark, setProductToMark] = useState(null)
  const [showSetAsWarningSingleProductAlertPopup, setShowSetAsWarningSingleProductAlertPopup] = useState(false)
  const [filterIsActive, setFilterIsActive] = useState(false)
  const [productToShowGradingCertificate, setProductToShowGradingCertificate] = useState(null)
  const [showCertificate, setShowCertificate] = useState(false)

  //Funzione jquery che mi permette di gestire la variazione dello z-index del menù azioni quando scrollo
  $(window).on("scroll", function () {
    scrollManagerInTabPages('#actions')
  });

  useEffect(() => {
    if (initCompleted && orderItems.length === 0) {
      getOrderItems()
    }
  }, [orderItems]);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      appendOrderItems(originalOrder.order_items)
    }
  }, []);


  // Hook che permette il caricamento di nuovi prodotti dell'ordine da renderizzare sull'interfaccia
  // grafica non appena l'utente scrolla fino in fondo alla pagina (INFINITE SCROLL)
  const scrollRef = useBottomScrollListener(() => getOrderItems());


  // Funzione che permette di ottenere dal server nuovi prodotti dell'ordine da renderizzare sull'interfaccia grafica
  const getOrderItems = () => {
    if (!hasLoadedAllOrderItems) {
      let url = `/orders/${originalOrder.id}/edit.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setLoading(false)
          appendOrderItems(data.order_items)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }




  // Funzione che permette di concatenare i nuovi prodotti ottenuti del server all'array che contiene tutti 
  // i prodotti dell'ordine da mostrare sull'interfaccia grafica all'utente
  const appendOrderItems = (newOrderItems) => {
    setOrderItems(orderItems.concat(newOrderItems));
    setAtLeastOneOrderItemWithoutState((orderItems.concat(newOrderItems)).find((item) => item.state === null))
    setPage(page + 1)
    if (newOrderItems.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllOrderItems(true)
  }


  // Funzione che permette di ottenere dal server i prodotti dell'ordine dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getOrderItemsByMatchingFilters = (filter, value) => {
    setFilterIsActive(true)
    const newFilters = { ...filters }
    newFilters[filter] = value;
    updateFilters(newFilters)
    if (window.innerWidth <= IPAD_WIDTH)
      setActionsPannelIsOpen(false)
  }


  // Funzione che aggiorna i filtri di ricerca dei prodotti specificati dall'utente sull'interfaccia grafica
  const updateFilters = (newFilters) => {
    setFilters(newFilters)
    setLoading(true)
    setPage(1)
    setHasLoadedAllOrderItems(false)
    setOrderItems([]);
    setAtLeastOneOrderItemWithoutState(false)
  }


  // Funzione che permette di modificare lo stato corrente dell'ordine
  const onChangeOrderStateHandler = (e, order, key, initialValue, newValue, courierId, newCourier, trackingNumber, problem) => {
    if (!isOrderInProgress) {
      let can_update = true;

      if (key === 'state') {
        can_update = false;
        if ((orderType === 'received' && initialValue === 'opened' && ['in_progress', 'sent'].includes(newValue)) ||
          (orderType === 'received' && initialValue === 'opened' && newValue === 'rejected' && problem !== null && problem !== "") ||
          (orderType === 'received' && initialValue === 'in_progress' && newValue === 'sent' && (courierId || newCourier)) ||
          (orderType === 'sent' && ['sent', 'warning'].includes(orderState) && newValue === 'received') ||
          (orderType === 'sent' && ['sent', 'warning'].includes(orderState) && newValue === 'warning' && problem !== null && problem !== "" && atLeastOneOrderItemWithoutState && order.can_warn_a_problem))
          can_update = true
      }

      if (can_update) {
        const body = {
          courier_id: courierId,
          new_courier: newCourier,
          tracking_number: trackingNumber,
        }
        if (newValue === 'rejected' && problem !== null && problem !== "")
          body['rejection_reason'] = problem

        if (newValue === 'warning' && problem !== null && problem !== "")
          body['rejecting_cause'] = problem

        if (key)
          body[key] = newValue

        const url = `/orders/${order.id}`;

        setIsOrderInProgress(true)

        fetch(url + ".json", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((res) => {
            setIsOrderInProgress(false)
            if (!res.ok)
              throw Error("An error occour during saving data on the database");
            else
              return res.json();
          })
          .then((data) => {
            setOrderState(newValue)
            if (courierId) {
              const newCourier = (couriersToRender.filter((courier) => courier[0] == courierId))[0];
              setCourierCompany({ id: newCourier[0], meta_name: newCourier[1] });
            }

            else if (newCourier) {
              setCouriersToRender([...couriersToRender].concat([[data.courier_id, newCourier]]))
              setCourierCompany({ id: data.courier_id, meta_name: newCourier });
            }

            if (trackingNumber && trackingNumber !== "")
              setTrackNumber(trackingNumber)
            else
              setTrackNumber(null)

            if (newValue === 'warning' && problem !== null && problem !== undefined && problem !== "") {
              let newOrderItems = orderItems.map((order_item) => {
                if (order_item.state === null) {
                  order_item['state'] = problem
                }
                return order_item;
              })
              setOrderItems(newOrderItems)
              setAtLeastOneOrderItemWithoutState(newOrderItems.find((item) => item.state === null))
            }

            else if (newValue === 'received') {
              let newOrderItems = orderItems.map((order_item) => {
                order_item['state'] = 'received'
                return order_item;
              })
              setOrderItems(newOrderItems)
              setAtLeastOneOrderItemWithoutState(newOrderItems.find((item) => item.state === null))
            }

            else if (newValue === 'rejected' && problem !== null && problem !== "") {
              setRejectionReason(problem)
            }

            setShowSuccessFlashMessage(true)
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });
      }
    }

    setOrderToSetShipmentData(null)
    setShipmentDataToUpdate(null)
  };



  //Funzione che permette di modificare lo stato corrente di una singola carta dell'ordine
  const onChangeOrderItemStateHandler = (orderItem, key, newState, problem) => {
    if (!isOrderInProgress) {
      let can_update = true;

      if (key === 'state') {
        can_update = false;
        if (orderType === 'sent' && ['sent', 'warning'].includes(orderState) && orderItem.state !== 'received' &&
          (newState === 'received' || problem !== null))
          can_update = true
      }

      if (can_update) {
        const body = {}
        body[key] = newState === 'received' ? newState : problem

        const url = `/order_items/${orderItem.id}`;

        setIsOrderInProgress(true)

        fetch(url + ".json", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((res) => {
            setIsOrderInProgress(false)
            if (!res.ok)
              throw Error("An error occour during saving data on the database");
            else
              return res.json();
          })
          .then((data) => {
            let newOrderItems = orderItems.map((order_item) => {
              if (order_item.id === orderItem.id) {
                order_item['state'] = newState === 'received' ? newState : problem
              }
              return order_item;
            })
            setOrderItems(newOrderItems)
            setAtLeastOneOrderItemWithoutState(newOrderItems.find((item) => item.state === null))
            setOrderState(data.state)
            setShowSuccessFlashMessage(true)
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });
      }
    }

    setOrderToSetShipmentData(null)
    setShipmentDataToUpdate(null)
  };


  //Funzione che permette di aggiornare i vari campi che compongono l'indirizzo di spedizione
  //con i dati immessi dall'utente sull'interfaccia grafica
  const updateShipmentAddressParams = (keys, values) => {
    const newShipmentAddress = { ...shipmentAddress }
    for (let i = 0; i < keys.length; i++)
      newShipmentAddress[keys[i]] = values[i]
    setShipmentAddress(newShipmentAddress)
  }


  //Funzione che aggiorna l'indirizzo di spedizione scelto dall'utente
  function updateShipmentAddress() {
    if (shipmentAddress.can_be_updated && orderState === 'opened') {
      if (isValidUserAddress(shipmentAddress)) {
        let url = `/orders/update_shipment_address/${originalOrder.id}?`;

        fetch(url + ".json", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(shipmentAddress),
        })
          .then((res) => {
            if (!res.ok)
              throw Error("An error occour during saving data on the database");
            else
              return res.json()
          })
          .then((data) => {
            setShipmentAddress({ ...shipmentAddress })
            setShowModal(false)
            setShowSuccessFlashMessage(true)
          })
          .catch((error) => {
            console.error("ERROR:", error);
            setShowErrorModal(true);
          });

      }
    }
  }


  // Funzione che si occupa di segnalare un problema riscontrato dal buyer relativamente all'intero ordine o a qualche
  // carta specifica
  const handleReject = () => {
    if (orderItemToReject) {
      if (orderItemToReject === 'all')
        onChangeOrderStateHandler(null, originalOrder, 'state', orderState, 'warning', courierCompany.id, courierCompany.meta_name, trackNumber, rejectingCause ? rejectingCause : otherRejectingCause)
      else
        onChangeOrderItemStateHandler(orderItemToReject, 'state', null, rejectingCause ? rejectingCause : otherRejectingCause)
      setOrderItemToReject(null)
    } else if (orderToReject) {
      onChangeOrderStateHandler(null, originalOrder, 'state', orderState, 'rejected', courierCompany.id, courierCompany.meta_name, trackNumber, rejectingCause ? rejectingCause : otherRejectingCause)
      setOrderToReject(null)
    }
  }

  const handleRejectingCause = (value) => {
    setRejectingCause(value)
    setOtherRejectingCause("");
  }

  const handleSetOtherRejectingCause = (value) => {
    setOtherRejectingCause(value);
    setRejectingCause(null)
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, blueprintImage) => {
    e.stopPropagation();
    if (blueprintImage) {
      setBlueprintImage2ShowLargeImage(blueprintImage)
      setShowZoomImg(true)
    }
  }

  // Funzione che mostra il popup per gestire la conferma di ricezione del prodotto
  const showPopupToMarkAsReceivedProduct = (e, product, type) => {
    e.stopPropagation();
    setProductToMark(product)
    type === 'received' && setShowSetAsRecivedSingleProductAlertPopup(true)
    type === 'warning' && setShowSetAsWarningSingleProductAlertPopup(true)
  }

  // Funzione che mostra il popup per gestire la conferma di ricezione del prodotto
  const resetAllFilter = () => {
    setFilterIsActive(false)
    updateFilters(initialFilters)
    if (window.innerWidth <= IPAD_WIDTH)
      setActionsPannelIsOpen(false)
  }



  // Funzione che traduce nella lingua corrente del sito l'eventuale motivo di reject di un ordine
  const translateRejectionReason = (rejectionReason) => {
    if (rejectionReason === 'products_no_longer_available') {
      return I18n.t('js.indexOrdersPage.productsNoLongerAvailable')
    } else if (rejectionReason === 'payment_not_received') {
      return I18n.t('js.indexOrdersPage.paymentNotReceived')
    } else {
      return titleize(rejectionReason)
    }
  }


  return (
    <React.Fragment>

      {/*menù azioni*/}
      {!actionsPannelIsOpen ?
        <React.Fragment>
          {/*mobile button*/}
          {
            orderItems.length > 0 &&
            <div className="button-show-all-sub-expansion-on-mobile show-on-mobile-d-block ">
              <button type="button" className="btn"
                onClick={() => setActionsPannelIsOpen(true)}>
                <i className="fas fa-pencil-alt icon-in-btn-size ml-8px text--size-27px-imp" />
              </button>
            </div>
          }

        </React.Fragment>
        :
        <React.Fragment>
          <div
            className={`${orderItems.length === 0 && window.innerWidth < DESKTOP_WIDTH && 'd-none'} pl-4 pr-4 pb-4 actions-menu-fixed-on-top scrollable-div bg-light overflow-auto shadow z-index-125`}
            id="actions">
            <div className="row">
              <div className="col-12 text-right p-lg-0">
                <button type="button" className="btn p-0 mt-8px mr-4px"
                  onClick={() => setActionsPannelIsOpen(false)}>
                  <i className="fas fa-times show-on-mobile" />
                </button>
              </div>
            </div>

            <div className="row mt-10px">

              <div className="col-lg-4 col-md-4 col-12 mb-2 mb-20px-imp">
                <p className="mb-0 text-space text-weight-700">
                  {I18n.t('js.editOrderPage.orderNumber')}&nbsp;<span className="font-weight-normal">{originalOrder.id}</span>
                </p>
                <p className="mb-0 text-space text-weight-700">
                  {I18n.t('js.editOrderPage.orderState')}&nbsp;
                  <span className="ml-1"
                    onClick={(e) => orderState === 'warning' && getOrderItemsByMatchingFilters('warning_cards', true)}
                    style={{
                      cursor: orderState === 'warning' ? 'pointer' : 'auto',
                      color: orderState === 'rejected' ? 'red' :
                        (orderState === 'in_progress' ? 'blue' :
                          (orderState === 'sent' ? 'darkOrange' :
                            (orderState === 'warning' ? 'red' :
                              (orderState === 'received' ? 'green' : 'black'))))
                    }}>
                    {parseOrderState(orderState)}
                    {orderState === 'warning' &&
                      <IconTooltip
                        tooltipPosition={'top'}
                        tooltipIcon={'fas fa-exclamation-triangle'}
                        tooltipTitle={I18n.t('js.editOrderPage.warningTooltipTitle')}
                        tooltipContent={I18n.t('js.editOrderPage.warningTooltipContent')}
                        iconColor={'red'}
                      />
                    }
                    {orderState === 'rejected' &&
                      <IconTooltip
                        tooltipPosition={'top'}
                        tooltipIcon={'fas fa-exclamation-triangle'}
                        tooltipTitle={I18n.t('js.editOrderPage.rejectedTooltipTitle')}
                        tooltipContent={translateRejectionReason(rejectionReason)}
                        iconColor={'red'}
                      />
                    }
                  </span>
                </p>
                <p className="mb-0 text-space text-weight-700">
                  {I18n.t('js.editOrderPage.productNumber')}&nbsp;<span className="font-weight-normal">{parseBigInteger(originalOrder.number_of_items)}</span></p>
                <p className="mb-0 text-space text-weight-700">
                  {I18n.t('js.editOrderPage.amount')}&nbsp;<span className="font-weight-normal">{parseAmount(originalOrder.products_price_purchase) + CURRENCY_EURO}</span></p>

                <p className="mb-0 text-space text-weight-700" >{I18n.t('js.indexOrdersPage.sortBy')}</p>

                <div className="d-flex justify-content-start align-items-center col-12 col-lg-8 p-0">
                  <select className={`form-control ${filters.sort_by ? 'border-aiG-blue-imp' : ''} mr-1`}
                    name="sort_by" id="sort_by" value={filters.sort_by}
                    style={{ minWidth: "60%" }}
                    onChange={(e) => getOrderItemsByMatchingFilters('sort_by', e.target.value)} >
                    {sorting_options.map(option => {
                      return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                    })}
                  </select>
                  <span>
                    <b>:</b>
                  </span>
                  <select className={`form-control ${filters.sorting_direction ? 'border-aiG-blue-imp' : ''} ml-1 mr-2`}
                    name="sorting_direction" id="sorting_direction" value={filters.sorting_direction}
                    onChange={(e) => getOrderItemsByMatchingFilters('sorting_direction', e.target.value)} >
                    {sorting_directions.map(direction => {
                      return <option value={direction.value} key={direction.value}>{I18n.t(direction.locale)}</option>
                    })}
                  </select>
                </div>

                <div className="d-flex justify-content-start align-items-center col-12 col-lg-8 p-0 mt-2">
                  <button
                    type="button"
                    className={`${!filterIsActive && 'd-none'} btn-standard border-blu-aiGrading icon--bg-active text-aiBlue pl-2 col-12 col-lg-6 h-auto btn-inside-table text-weight-700 pt-6px-imp`}
                    onClick={() => resetAllFilter()}>
                    {I18n.t('js.filters.resetFilter')}
                  </button>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-12 mb-2 mb-20px-imp">
                {
                  orderType === 'sent' ?
                    //menu per Compratore
                    <React.Fragment>
                      <p className="mb-0 text-space text-weight-700">
                        {I18n.t('js.editOrderPage.seller')}&nbsp;<span className="font-weight-normal">{originalOrder.seller.username}</span>
                      </p>
                      <p className="mb-0 text-space text-weight-700">
                        {I18n.t('js.editOrderPage.mail')}&nbsp;<span className="font-weight-normal">{originalOrder.seller.email}</span>
                      </p>
                    </React.Fragment>
                    :
                    //menu per venditore
                    <React.Fragment>
                      <p className="mb-0 text-space text-weight-700">
                        {I18n.t('js.editOrderPage.buyer')}&nbsp;<span className="font-weight-normal">{originalOrder.buyer.username}</span>
                      </p>
                      <p className="mb-0 text-space text-weight-700">
                        {I18n.t('js.editOrderPage.mail')}&nbsp;<span className="font-weight-normal">{originalOrder.buyer.email}</span>
                      </p>
                    </React.Fragment>
                }

                {
                  shipmentAddress &&
                  <React.Fragment>
                    <p className="mb-0 text-space text-weight-700">
                      {I18n.t('js.editOrderPage.shipmentAddress')}
                    </p>
                    <p className="mb-0 text-space font-weight-normal pl-lg-3">{parseUserFullName(shipmentAddress.first_name, shipmentAddress.last_name)}</p>
                    <p className="mb-0 text-space font-weight-normal pl-lg-3"> {shipmentAddress.street_square + ' ' + shipmentAddress.number + (shipmentAddress.indoor ? ', ' + shipmentAddress.indoor : '')}</p>
                    <p className="mb-0 text-space font-weight-normal pl-lg-3"> {shipmentAddress.cap + ' ' + shipmentAddress.city}</p>
                    <p className="mb-0 text-space font-weight-normal pl-lg-3"> {shipmentAddress.province.toUpperCase() + ' (' + shipmentAddress.country.toUpperCase() + ')'}</p>
                    {
                      shipmentAddress.phone_number &&
                      <p className="mb-0 text-space font-weight-normal pl-lg-3">
                        {I18n.t('js.editOrderPage.phone')}&nbsp;{shipmentAddress.phone_number}
                      </p>
                    }
                    {
                      orderType === 'received' &&
                      <div className="col-12 text-center mb-10px p-0 d-block mt-3">
                        <PDFGenerator
                          type={'button'}
                          generatorText={I18n.t('js.editSubmissionListPage.userShipmentAddress')}
                          cssClassList={"btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-50px"}
                          pdfUrl={`/orders/${originalOrder.id}/shipment_address_label`}
                          setShowErrorModal={setShowErrorModal}
                        />
                      </div>
                    }
                  </React.Fragment>
                }
              </div>


              <div className="col-lg-4 col-md-4 col-12 mb-2 mb-20px-imp">
                {
                  courierCompany && courierCompany.meta_name &&
                  <p className="mb-0 text-space text-weight-700">{I18n.t('js.editOrderPage.courier')}&nbsp;
                    <span className="font-weight-normal">{courierCompany.meta_name}</span>
                  </p>
                }

                {
                  trackNumber && trackNumber !== "" &&
                  <p className="mb-2 text-space text-weight-700">{I18n.t('js.editOrderPage.trackingNumber')}&nbsp;
                    <span className="font-weight-normal">{trackNumber}</span>
                  </p>
                }

                {
                  courierCompany && courierCompany.meta_name && orderType === 'received' && ['sent', 'warning'].includes(orderState) &&
                  <button
                    className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-auto mb-3 mb-3 text-center"
                    onClick={(e) => {
                      setOrderToSetShipmentData({ ...originalOrder, state: orderState });
                      setShipmentDataToUpdate({ courier: { id: courierCompany.id, meta_name: courierCompany.meta_name }, tracking_number: trackNumber })
                    }}>
                    {I18n.t('js.editOrderPage.updateTracking')}
                  </button>
                }

                <a
                  href={`/orders?orders_type=${orderType}`}
                  className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-auto mb-3 mb-3 text-center show-on-desktop-d-block">
                  {orderType === 'sent' ? I18n.t('js.editOrderPage.submittedOrders') : I18n.t('js.editOrderPage.receivedOrders')}
                </a>

                {
                  orderType === 'sent' ?
                    //bottoni per Compratore

                    <React.Fragment>
                      {
                        shipmentAddress.can_be_updated &&
                        <button
                          type="button"
                          className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-auto mb-3 mb-3"
                          onClick={() => setShowModal(true)}>
                          {I18n.t('js.editSubmissionListPage.changeShipmentAddress')}
                        </button>
                      }

                      {
                        ['sent', 'warning'].includes(orderState) &&
                        <React.Fragment>
                          <button
                            type="button"
                            className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-auto mb-3"
                            onClick={(e) =>
                              setShowReceiveAllProductInOrderAlertPopup(true)
                            }>
                            {I18n.t('js.editOrderPage.markAllAsReceived')}
                          </button>

                          {
                            originalOrder.can_warn_a_problem && atLeastOneOrderItemWithoutState &&
                            <button
                              type="button"
                              className="btn-standard-outline-danger pr-2 pl-2 w-120px btn-standard-outline-resized h-auto btn-inside-table mt-3 col-12 col-lg-8 mb-3"
                              onClick={(e) =>
                                setShowAlertProblemOnAllProductAlertPopup(true)
                              }
                            >
                              <i className="fas fa-exclamation-triangle mr-10px" />
                              {I18n.t('js.indexOrdersPage.markProblem')}
                            </button>
                          }
                        </React.Fragment>
                      }
                    </React.Fragment>
                    :
                    // bottoni per venditore
                    <React.Fragment>
                      {
                        orderState === 'opened' &&
                        <React.Fragment>
                          <button
                            type="button"
                            className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-auto mb-3"
                            onClick={(e) =>
                              setShowSetInProgressOrderAlertPopup(true)
                            }
                          >
                            {I18n.t('js.editOrderPage.markAllAsInProgress')}
                          </button>

                          <button
                            type="button"
                            className="btn-standard-outline-danger pr-2 pl-2 w-120px btn-standard-outline-resized h-auto btn-inside-table mt-3 col-12 col-lg-8 mb-3"
                            onClick={(e) =>
                              setOrderToReject(originalOrder)
                            }
                          >
                            <i className="fas fa-exclamation-triangle mr-10px" />
                            {I18n.t('js.indexOrdersPage.rejectOrder')}
                          </button>
                        </React.Fragment>
                      }
                      {
                        orderState === 'in_progress' &&

                        <button
                          type="button"
                          className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-auto mb-3"
                          onClick={(e) =>
                            setShowSentOrderAlertPopup(true)
                          }
                        >
                          {I18n.t('js.editOrderPage.markAllAsSent')}
                        </button>
                      }
                    </React.Fragment>
                }

                <PDFGenerator
                  type={'button'}
                  generatorText={I18n.t('js.editOrderPage.printOrder')}
                  cssClassList={"btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized col-12 col-lg-8 h-50px"}
                  pdfUrl={`/orders/${originalOrder.id}/edit.pdf`}
                  setShowErrorModal={setShowErrorModal}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      }

      <div className="w-90 m-auto mt-350px-imp">

        <h2 className='text-left text-md-center text-lg-left p-3 mb-2 mt-3 w-90'>
          {orderState === 'opened' ?
            I18n.t('js.editOrderPage.myReceivedOrder')
            : I18n.t('js.editOrderPage.mySubmittedOrder')
          }&nbsp;{originalOrder.id}
        </h2>

        <div className="container show-on-mobile">
          <div className={`row ${$(window).innerWidth() > 750 && 'w-100'}`}>

            <div className="col-6 col-md-4 mb-2 mb-20px-imp">
              <div className="d-flex align-items-center h-100">
                <h3 className="mb-0 mt-20px">
                  {parseBigInteger(originalOrder.number_of_items)}&nbsp;
                  {pluralize(originalOrder.number_of_items, 'editSubmissionListPage.product')}
                </h3>
              </div>
            </div>

            <div className="col-6 col-md-4 mb-2 mb-20px-imp ">
              <div className="d-flex align-items-center h-100">
                <h3 className="mb-0 mt-20px">
                  {I18n.t('js.editSubmissionListPage.price')}&nbsp;
                  {parseAmount(originalOrder.products_price_purchase) + CURRENCY_EURO}
                </h3>
              </div>
            </div>

            <div className="col-12 col-md-4 mt-2">
              <a
                href={`/orders?orders_type=${orderType}`}
                className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized h-auto mb-3 text-center show-on-mobile-d-block">
                {orderType === 'sent' ? I18n.t('js.editOrderPage.submittedOrders') : I18n.t('js.editOrderPage.receivedOrders')}
              </a>
            </div>

          </div>
        </div>


        {
          loading ?
            <div className="d-flex justify-content-center mt-5">
              <div className="d-flex align-items-center text-muted">
                <div className="spinner-border" role="status" />
                <b className="ml-2">{I18n.t('js.common.loading')}</b>
              </div>
            </div>
            :
            orderItems.length > 0 ?
              <BottomScrollListener onBottom={getOrderItems}>
                <div className="d-none d-lg-block table-responsive">
                  <table id="order-edit"
                    className="table table-hover mt-10px bg-white">
                    <thead className="thead-dark">
                      <tr>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderImage')}</th>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderProperty')}</th>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderName')}</th>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderGame')}</th>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderCategory')}</th>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderEra')}</th>
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderExpansion')}</th>
                        {
                          isBusinessAccount &&
                          <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderCondition')}</th>
                        }
                        <th className="text-center">{I18n.t('js.myCollectionEditPage.tableHeaderGrading')}</th>
                        <th className="text-center">{I18n.t('js.filters.sort.encasing')}</th>
                        <th className="text-center">{I18n.t('js.filters.sort.labelLanguage')}</th>
                        <th className="text-center">{I18n.t('js.editOrderPage.tableHeaderErrors')}</th>
                        <th className="text-center">{I18n.t('js.filters.sort.cardPrice')}</th>
                        <th className="text-center">{orderType === 'sent' ? I18n.t('js.indexOrdersPage.tableHeaderManageActions') : I18n.t('js.editOrderPage.tableHeaderProductState')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderItems.map((item, i) => {
                        return (<tr key={item.id} id={item.id}
                          className={item.product.enable_grading_certificate && item.grading.serial_number ? "cursor-pointer" : ""}
                          onClick={() => item.product.enable_grading_certificate && item.grading.serial_number ? window.location = `/grading_certificate/${item.grading.serial_number}` : {}}
                        >
                          <BlueprintImageTableRaw
                            blueprintImage={item.product.blueprint_image}
                            handleShowLargeImage={handleShowLargeImage}
                            id={item.id}
                            displayEra={true}
                          />

                          {
                            isBusinessAccount &&
                            <td className="text-center ml-td">
                              <p className="mb-0">{parseItemCondition(item.product.condition)}</p>
                            </td>
                          }
                          <td className="text-center ml-td">
                            <p className="text-weight-700 mt-0" style={{ color: "green" }}>
                              {parseGradeOverall(item.grading)}
                            </p>
                            <small>({item.grading.serial_number})</small>

                            {
                              item.product.enable_grading_certificate &&
                              <button type="button"
                                id="aig-certificate"
                                className="mt-10px btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-inside-table text--white-space-no-wrap"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setBlueprintImage2ShowLargeImage(item.product.blueprint_image);
                                  setProductToShowGradingCertificate(item);
                                  setShowCertificate(true);
                                }}
                              >
                                <i className="fas fa-award" />
                                &nbsp; {I18n.t("js.showCertificateModal.certificate")}
                              </button>
                            }
                          </td>
                          <td className="text-center ml-td">
                            <p className="mb-0">
                              <EncasingParser
                                encasing={item.grading.encasing}
                                categoryName={item.product.blueprint_image.blueprint.category.name}
                              />
                            </p>
                          </td>
                          <td className="text-center ml-td">
                            <div className="mb-0">
                              <LanguageFlag
                                language={item.grading.label_language}
                                containerCssClassList={'d-flex justify-content-center'}
                              />
                            </div>
                          </td>
                          <td className="text-center ml-td">
                            <p className="mb-0 text-capitalize">
                              {item.grading.qualifier &&
                                item.grading.qualifier !== "none"
                                ? item.grading.qualifier.replaceAll("_", " ")
                                : I18n.t("js.editCartPage.none")}
                            </p>
                          </td>
                          <td className="text-center ml-td">
                            <p className="mb-0"> {parseAmount(item.price_purchase) + CURRENCY_EURO}</p>
                          </td>
                          <td id={"state_" + item.id} className="text-center ml-td max-w-350px">
                            {
                              item.state === "received" ?
                                <p className="mb-0 text-weight-700"
                                  style={{ color: "green" }}>{I18n.t("js.common.ordersState.received")}</p>
                                :
                                item.state !== null &&
                                <React.Fragment>
                                  <p className="mb-0 text-weight-700" style={{ color: "red" }}>
                                    {I18n.t("js.common.ordersState.warning")}
                                  </p>
                                  <p className="text-weight-700 text-overflow-wrap" style={{ color: "red" }}>
                                    {I18n.t("js.editOrderPage.cause")}&nbsp;{titleize(item.state)}
                                  </p>
                                </React.Fragment>
                            }
                            {
                              orderType === "sent" && ["sent", "warning"].includes(orderState) && item.state !== "received" &&
                              <div className="d-block">
                                <button
                                  id={"confirmReceivedOrMarkResolved_" + item.id}
                                  type="button"
                                  className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-inside-table text--white-space-no-wrap max-w-250px-imp"
                                  onClick={(e) => showPopupToMarkAsReceivedProduct(e, item, "received")}
                                >
                                  {
                                    item.state === null ? I18n.t("js.editOrderPage.markProductAsReceived") :
                                      (item.state !== "received" && originalOrder.can_warn_a_problem) &&
                                      I18n.t("js.indexOrdersPage.markProblemSolved")
                                  }

                                </button>
                                {
                                  item.state === null && originalOrder.can_warn_a_problem &&
                                  <button
                                    type="button"
                                    className="btn-standard-outline-danger pr-2 pl-2 max-w-250px-imp btn-standard-outline-resized h-auto btn-inside-table mt-3"
                                    onClick={(e) => showPopupToMarkAsReceivedProduct(e, item, "warning")}>
                                    <i className="fas fa-exclamation-triangle mr-10px" />
                                    {I18n.t("js.editOrderPage.markProductWithProblem")}
                                  </button>
                                }
                              </div>
                            }
                          </td>
                        </tr>)
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="show-on-mobile-d-block mt-20px">
                  {orderItems.map((item, i) => {
                    return (<Accordion defaultActiveKey={orderItems[0].id} className="w-100 mb-3 border-aiG-black-imp br-8px" key={item.id}>
                      <Card className="bg-white border-none border-round-standard">
                        <Accordion.Toggle as={Card.Header} eventKey={item.id}>

                          <div className="row">
                            <BlueprintImageAccordionTitleImage
                              blueprintImage={item.product.blueprint_image}
                              handleShowLargeImage={handleShowLargeImage}
                            />

                            <BlueprintImageAccordionTitleName
                              blueprintImage={item.product.blueprint_image}
                            />

                            <div className="col-3 col-md-2 p-0 text-center d-flex align-items-center">
                              <BlueprintImageAccordionTitleIcon
                                blueprintImage={item.product.blueprint_image}
                              />

                              {
                                item.state === "received" ?
                                  <p className="mb-0 text-weight-700 d-flex align-items-center"
                                    style={{ color: "green" }}>{I18n.t("js.common.ordersState.received")}</p>
                                  :
                                  item.state !== null &&
                                  <React.Fragment>
                                    <p className="mb-0 text-weight-700" style={{ color: "red" }}>
                                      {I18n.t("js.common.ordersState.warning")}
                                    </p>
                                  </React.Fragment>
                              }
                            </div>
                          </div>
                        </Accordion.Toggle>

                        <Accordion.Collapse eventKey={item.id}>
                          <div className="row mt-10px pb-3">
                            <div className="col-12">
                              <BlueprintImageAccordionContent
                                blueprintImage={item.product.blueprint_image}
                                isProduct={true}
                              />

                              <div className="row">
                                {
                                  isBusinessAccount &&
                                  <React.Fragment>
                                    <div className="col-xs-3 col-md-2">
                                      <p
                                        className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.condition")}:</p>
                                    </div>

                                    <div className="col-xs-9 col-md-4">
                                      <p
                                        className="pr-20px text-right text-md-left pl-md-2 mb-0">{parseItemCondition(item.product.condition)}</p>
                                    </div>
                                  </React.Fragment>
                                }
                              </div>

                              <div className="row">
                                <div className="col-xs-3 col-md-2">
                                  <p
                                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.cardGrading")}:</p>
                                </div>

                                <div className="col-xs-9 col-md-4">
                                  <div className="pr-20px text-right text-md-left pl-md-2 mb-3">
                                    <p className="mb-2 text-weight-700" style={{ color: "green" }}>
                                      {parseGradeOverall(item.grading)}
                                    </p>
                                    <small>({item.grading.serial_number})</small>

                                    {
                                      item.product.enable_grading_certificate &&
                                      <div>
                                        <div className="col-9 px-0 py-1">
                                          <button type="button"
                                            id="aig-certificate"
                                            className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-my-collection-accordion"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setBlueprintImage2ShowLargeImage(item.product.blueprint_image);
                                              setProductToShowGradingCertificate(item);
                                              setShowCertificate(true);
                                            }}
                                          >
                                            <i className="fas fa-award" />
                                            &nbsp; {I18n.t("js.showCertificateModal.certificate")}
                                          </button>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                </div>

                                <div className="col-xs-3 col-md-2">
                                  <p
                                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.encasing")}:</p>
                                </div>

                                <div className="col-xs-9 col-md-4">
                                  <p className="pr-20px text-right text-md-left pl-md-2 mb-0">
                                    <EncasingParser
                                      encasing={item.grading.encasing}
                                      categoryName={item.product.blueprint_image.blueprint.category.name}
                                    />
                                  </p>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-xs-3 col-md-2">
                                  <p
                                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.labelLanguage")}:</p>
                                </div>

                                <div className="col-xs-9 col-md-4">
                                  <div className="pr-20px text-right text-md-left pl-md-5 mb-0">
                                    <LanguageFlag
                                      language={item.grading.label_language}
                                      containerCssClassList={'d-flex justify-content-end'}
                                    />
                                  </div>
                                </div>

                                <div className="col-xs-7 col-md-2">
                                  <p
                                    className="pl-20px text-weight-500">{I18n.t("js.editOrderPage.tableHeaderErrors")}:</p>
                                </div>

                                <div className="col-xs-5 col-md-4">
                                  <p className="pr-20px text-right text-md-left pl-md-2 mb-0 text-capitalize">
                                    {item.grading.qualifier && item.grading.qualifier !== "none"
                                      ? item.grading.qualifier.replaceAll("_", " ")
                                      : I18n.t("js.editCartPage.none")}</p>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-xs-3 col-md-2">
                                  <p
                                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.cardPrice")}:</p>
                                </div>

                                <div className="col-xs-9 col-md-4">
                                  <p
                                    className="pr-20px text-right text-md-left pl-md-2 mb-0">{parseAmount(item.price_purchase) + CURRENCY_EURO}</p>
                                </div>

                                {
                                  (item.state === "received" || item.state !== null) &&
                                  <React.Fragment>
                                    <div className="col-xs-3 col-md-2">
                                      <p
                                        className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.state")}:</p>
                                    </div>

                                    <div className="col-xs-9 col-md-4">
                                      {item.state === "received" ?
                                        <p className="pr-20px text-right text-md-left pl-md-5 mb-0 text-weight-700"
                                          style={{ color: "green" }}>{I18n.t("js.common.ordersState.received")}</p>
                                        :
                                        item.state !== null &&
                                        <React.Fragment>
                                          <p className="pr-20px text-right text-md-left pl-md-5 mb-0 text-weight-700"
                                            style={{ color: "red" }}>
                                            {I18n.t("js.common.ordersState.warning")}
                                          </p>
                                          <p className="pr-20px text-right text-md-left pl-md-5 mb-0"
                                            style={{ color: "red" }}>
                                            {I18n.t("js.editOrderPage.cause")}&nbsp;{titleize(item.state)}
                                          </p>
                                        </React.Fragment>
                                      }
                                    </div>
                                  </React.Fragment>
                                }
                              </div>

                              <div className="row">
                                {
                                  orderType === "sent" && ["sent", "warning"].includes(orderState) && item.state !== "received" &&
                                  <React.Fragment>
                                    <div className="col-12 col-md-6">
                                      {
                                        item.state === null && originalOrder.can_warn_a_problem &&
                                        <button
                                          type="button"
                                          className="btn-standard-outline-danger pr-2 pl-2 btn-standard-outline-resized pt-4px-imp h-auto btn-my-collection-accordion"
                                          onClick={(e) => showPopupToMarkAsReceivedProduct(e, item, "warning")}>
                                          <i className="fas fa-exclamation-triangle mr-10px" />
                                          {I18n.t("js.editOrderPage.markProductWithProblem")}
                                        </button>
                                      }
                                    </div>

                                    <div className="col-12 col-md-6">
                                      <button
                                        type="button"
                                        className="btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-my-collection-accordion mt-3 mt-md-0"
                                        onClick={(e) =>
                                          showPopupToMarkAsReceivedProduct(e, item, "received")
                                        }
                                      >
                                        {
                                          item.state === null ? I18n.t("js.editOrderPage.markProductAsReceived") :
                                            (item.state !== "received" && originalOrder.can_warn_a_problem) &&
                                            I18n.t("js.indexOrdersPage.markProblemSolved")
                                        }
                                      </button>
                                    </div>
                                  </React.Fragment>
                                }
                              </div>
                            </div>
                          </div>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>)
                  })}
                </div>

                {
                  !hasLoadedAllOrderItems && orderItems.length > 0 &&
                  <div className="d-flex justify-content-center mt-5">
                    <div className="d-flex align-items-center text-muted">
                      <div className="spinner-border" role="status" />
                      <b className="ml-2">{I18n.t('js.common.loading')}</b>
                    </div>
                  </div>
                }


              </BottomScrollListener>
              :
              <div className="d-flex justify-content-center mt-2 pt-3">
                <div className="d-flex align-items-center text-muted">
                  <p className="text-space text-weight-500">{I18n.t('js.editOrderPage.emptyOrder')}</p>
                </div>
              </div>
        }

      </div>

      <AddressFormContainerModal
        showModal={showModal}
        setShowModal={setShowModal}
        shipmentAddress={shipmentAddress}
        updateShipmentAddressParams={updateShipmentAddressParams}
        countries={countries}
        updateShipmentAddress={updateShipmentAddress}
        canUpdate={true}
        addressType={'user'}
      />

      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
      />

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />

      <ShipmentDataModal
        dataStructureToSetShipmentData={orderToSetShipmentData}
        setDataStructureToSetShipmentData={setOrderToSetShipmentData}
        couriers={couriersToRender}
        onChangeOrderStateHandler={onChangeOrderStateHandler}
        dataToUpdate={shipmentDataToUpdate}
        setDataToUpdate={setShipmentDataToUpdate}
        enableCustomCourier={true}
      />

      <RejectingModal
        itemToReject={orderToReject || orderItemToReject}
        setItemToReject={orderToReject ? setOrderToReject : setOrderItemToReject}
        rejectingCauses={orderToReject ? possibleOrdersRejectingCauses : possibleOrderItemsRejectingCauses}
        rejectingCause={rejectingCause}
        handleRejectingCause={handleRejectingCause}
        otherRejectingCause={otherRejectingCause}
        handleSetOtherRejectingCause={handleSetOtherRejectingCause}
        handleReject={handleReject}
        rejectConfirmMessage={I18n.t('js.modalRejecting.confirmRejectOrderContent')}
      />

      <FullScreenLoadingOverlay
        showFullScreenLoadingOverlay={isOrderInProgress}
        textFullScreenLoadingOverlay={I18n.t('js.editOrderPage.orderInProgress')}
      />

      <ShowLargeImageModal
        blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showZoomImg={showZoomImg}
        setShowZoomImg={setShowZoomImg}
      />

      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.grading : ''}
        originalLabel={productToShowGradingCertificate ? productToShowGradingCertificate.current_label : ''}
        originalBlueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />

      {/*Alert per cambio stato ordine con In progress*/}
      <AlertPopup
        showAlertPopup={showSetInProgressOrderAlertPopup}
        onSuccess={() => onChangeOrderStateHandler(null, originalOrder, 'state', orderState, 'in_progress', null, null, null, null)}
        onDiscard={setShowSetInProgressOrderAlertPopup}
        popupTitle={I18n.t('js.indexOrdersPage.modalChangeOrderStatusTilte')}
        popupContent={I18n.t('js.editOrderPage.alertPopupSetOrderInProgress')}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirm').toUpperCase()}`}
      />

      {/*Alert per cambio stato ordine con Sent*/}
      <AlertPopup
        showAlertPopup={showSentOrderAlertPopup}
        onSuccess={() => setOrderToSetShipmentData({ ...originalOrder, state: orderState })}
        onDiscard={setShowSentOrderAlertPopup}
        popupTitle={I18n.t('js.indexOrdersPage.modalChangeOrderStatusTilte')}
        popupContent={I18n.t('js.editOrderPage.alertPopupSetOrderSent')}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirm').toUpperCase()}`}
      />

      {/*Alert per cambio stato ordine con Received su tutti i prodotti*/}
      <AlertPopup
        showAlertPopup={showReceiveAllProductInOrderAlertPopup}
        onSuccess={() => onChangeOrderStateHandler(null, originalOrder, 'state', orderState, 'received', originalOrder.courier.id, originalOrder.courier.meta_name, originalOrder.tracking_number, null)}
        onDiscard={setShowReceiveAllProductInOrderAlertPopup}
        popupTitle={I18n.t('js.indexOrdersPage.modalChangeOrderStatusTilte')}
        popupContent={orderState === 'warning' ? I18n.t('js.editOrderPage.alertPopupSetOrderResolvedProblem') : I18n.t('js.editOrderPage.alertPopupSetOrderAsReceived')}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirm').toUpperCase()}`}
      />

      {/*Alert per cambio stato ordine con Problema su tutti i prodotti*/}
      <AlertPopup
        showAlertPopup={showAlertProblemOnAllProductAlertPopup}
        onSuccess={() => setOrderItemToReject('all')}
        onDiscard={setShowAlertProblemOnAllProductAlertPopup}
        popupTitle={I18n.t('js.indexOrdersPage.modalChangeOrderStatusTilte')}
        popupContent={I18n.t('js.editOrderPage.alertPopupSetOrderAsProblem')}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirm').toUpperCase()}`}
      />

      {/*Alert per cambio stato singolo prodotto ricevuto*/}
      <AlertPopup
        showAlertPopup={showSetAsRecivedSingleProductAlertPopup}
        onSuccess={() => onChangeOrderItemStateHandler(productToMark, 'state', 'received', null)}
        onDiscard={setShowSetAsRecivedSingleProductAlertPopup}
        popupTitle={I18n.t('js.indexOrdersPage.modalChangeOrderStatusTilte')}
        popupContent={orderState === 'warning' ? I18n.t('js.editOrderPage.alertPopupSetProductResolvedProblem') : I18n.t('js.editOrderPage.alertPopupSetProductAsReceived')}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirm').toUpperCase()}`}
      />

      {/*Alert per cambio stato singolo prodotto con warning*/}
      <AlertPopup
        showAlertPopup={showSetAsWarningSingleProductAlertPopup}
        onSuccess={() => setOrderItemToReject(productToMark)}
        onDiscard={setShowSetAsWarningSingleProductAlertPopup}
        popupTitle={I18n.t('js.indexOrdersPage.modalChangeOrderStatusTilte')}
        popupContent={I18n.t('js.editOrderPage.alertPopupSetProductAsProblem')}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirm').toUpperCase()}`}
      />
    </React.Fragment>
  );
}


export default OrderPage;